var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4763_2345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12H5.5C4.673 12 4 12.673 4 13.5V15.5C4 16.327 4.673 17 5.5 17H7.5C8.327 17 9 16.327 9 15.5V13.5C9 12.673 8.327 12 7.5 12ZM8 15.5C8 15.776 7.775 16 7.5 16H5.5C5.225 16 5 15.776 5 15.5V13.5C5 13.224 5.225 13 5.5 13H7.5C7.775 13 8 13.224 8 13.5V15.5ZM19.5 2H18V0.5C18 0.224 17.776 0 17.5 0C17.224 0 17 0.224 17 0.5V2H7V0.5C7 0.224 6.776 0 6.5 0C6.224 0 6 0.224 6 0.5V2H4.5C2.019 2 0 4.019 0 6.5V19.5C0 21.981 2.019 24 4.5 24H19.5C21.981 24 24 21.981 24 19.5V6.5C24 4.019 21.981 2 19.5 2ZM4.5 3H19.5C21.43 3 23 4.57 23 6.5V8H1V6.5C1 4.57 2.57 3 4.5 3ZM19.5 23H4.5C2.57 23 1 21.43 1 19.5V9H23V19.5C23 21.43 21.43 23 19.5 23Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4763_2345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDay);
export default __webpack_public_path__ + "static/media/calendar-day.0ee8b7824ce4cd309f0275ac89fbe4e2.svg";
export { ForwardRef as ReactComponent };